export const DEFAULT_NFT_ADDRESS = "0x669E5A6BBf8A8a07351A732b9dDDA7c14ba2d454";
export const NFT_SALE_CONTRACT_ADDRESS =
  "0xf5b6b5d1a46c4528fa5e1e07b28f2Ab4aF6FF975";

export const CHECKIN_CONTRACT_ADDRESS =
  "0x5f9e14FD1a208C366551f6668D48ba5eb9eE5969";
export const AUCTION_CONTRACT_ADDRESS =
  "0x6c97370b53027b784DCa9944A7F7aDf8dBCa6512";
export const USDT_CONTRACT_ADDRESS =
  "0x55d398326f99059ff775485246999027b3197955";
export const AUCTION_QUOTE_SYMBOL = "USDT";
